var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5554,
    cy: 19.5554,
    r: 19.5554,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5748 15.2447C14.8795 14.9492 14.584 14.0887 15.0012 13.463C15.8443 12.2114 17.2522 11.2988 19.1122 11.2988C21.1546 11.2988 22.5539 12.2288 23.2666 13.3934C23.875 14.3929 24.2314 16.2616 23.2927 17.6522C22.2497 19.1905 21.2502 19.6599 20.7114 20.6507C20.581 20.8853 20.5028 21.0765 20.4506 21.4676C20.3724 22.1021 19.8509 22.5975 19.2078 22.5975C18.4516 22.5975 17.8346 21.9457 17.9215 21.1895C17.9736 20.7463 18.0779 20.2856 18.3213 19.8511C18.9905 18.643 20.2768 17.9303 21.0243 16.8613C21.8152 15.7401 21.3719 13.6455 19.1296 13.6455C18.1127 13.6455 17.4521 14.1756 17.0436 14.8101C16.7395 15.3055 16.105 15.462 15.5748 15.2447ZM20.8591 26.074C20.8591 27.0301 20.0769 27.8123 19.1209 27.8123C18.1648 27.8123 17.3826 27.0301 17.3826 26.074C17.3826 25.118 18.1648 24.3358 19.1209 24.3358C20.0769 24.3358 20.8591 25.118 20.8591 26.074Z",
    fill: "#367FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionMark);
export default __webpack_public_path__ + "static/media/icon-question-mark.c0200709980c9d260373ab710652364b.svg";
export { ForwardRef as ReactComponent };